import moment from 'moment'
import { datetimeToSec } from '@/common/js/filters.js'

const urlRegExp = /^(https?:\/\/(([a-zA-Z0-9]+-?)+[a-zA-Z0-9]+\.)+[a-zA-Z]+)(:\d+)?(\/.*)?(\?.*)?(#.*)?$/

export default class DailyReports {
  /**
   * @description: 报表模板类型
   * @enum 1 平台投放日报
   * @enum 2 平台运营日报
   * @enum 3 产品发行日报
   * @enum 4 新运营日报
   * @enum 5 综合效果报表
   * @enum 6 定制报表1
   */
  static REPORTS_TEMPLATE_TYPES = {
    MARKET: 1,
    OPERATION: 2,
    DISTRIBUTE: 3,
    NEW_OPERATION: 4,
    EFFECTIVE: 5,
    CUSTOM1: 6,
    JJKL: 7
  }

  /**
   * @description: 报表模板类型列表
   */
  static REPORTS_TEMPLATE_TYPES_LIST = [
    { name: '街机小游戏定制报表', value: this.REPORTS_TEMPLATE_TYPES.JJKL },
    { name: '定制报表1', value: this.REPORTS_TEMPLATE_TYPES.CUSTOM1 },
    { name: '综合效果报表', value: this.REPORTS_TEMPLATE_TYPES.EFFECTIVE },
    { name: '新运营日报', value: this.REPORTS_TEMPLATE_TYPES.NEW_OPERATION },
    { name: '平台投放日报', value: this.REPORTS_TEMPLATE_TYPES.MARKET },
    // { name: '平台运营日报', value: this.REPORTS_TEMPLATE_TYPES.OPERATION },
    { name: '产品发行日报', value: this.REPORTS_TEMPLATE_TYPES.DISTRIBUTE }
  ]

  /**
   * @description: 游戏平台类型列表
   */
  static GAME_PLATFORM_LIST = [
    { label: 'IOS', value: 2 },
    { label: '安卓', value: 1 },
    { label: '小程序', value: 3 },
    { label: 'PC', value: 4 },
    { label: '鸿蒙', value: 5 }
  ]

  /**
   * @description: 发送任务状态类型
   * @enum 1 成功
   * @enum 0 失败
   */
  static REPORTS_SEND_STATUS = {
    SUCC: 1,
    FAIL: 0
  }

  /**
   * @description: 发送任务状态类型列表
   */
  static REPORTS_SEND_STATUS_LIST = [
    { label: '成功', value: this.REPORTS_SEND_STATUS.SUCC },
    { label: '失败', value: this.REPORTS_SEND_STATUS.FAIL }
  ]

  /**
   * @description: 综合效果报表数据类型
   * @enum 1 分日
   * @enum 0 实时
   */
  static DATA_TYPE = {
    BY_DAY: 0,
    REAL_TIME: 1
  }

  /**
   * @description: 新增任务可选周日期
   */
  static NEW_TASK_WEEK_DAYS_VALUE = ['1', '2', '3', '4', '5', '6', '7']
  static NEW_TASK_WEEK_DAYS_LABEL = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日']

  /**
   * @description: 新增任务可选周日期列表
   */
  static NEW_TASK_WEEK_DAYS_LIST = this.NEW_TASK_WEEK_DAYS_VALUE.map((v, i) => ({ label: this.NEW_TASK_WEEK_DAYS_LABEL[i], value: v }))

  /**
   * @description: 报表接收方式、报表接收方式列表
   * @enum 1 个人钉钉
   * @enum 2 邮箱
   * @enum 3 钉钉群
   */
  static RECIEVE_TYPES = {
    DING: '1',
    EMAIL: '2',
    DING_GROUP: '3'
  }

  static RECIEVE_TYPES_LIST = [
    { value: this.RECIEVE_TYPES.DING, label: '个人钉钉' },
    { value: this.RECIEVE_TYPES.EMAIL, label: '邮箱' },
    { value: this.RECIEVE_TYPES.DING_GROUP, label: '钉钉群' }
  ]

  /**
   * @description: form提交验证
   */
  static makeFormValidateRules() {
    const gameValidator = (rule, value, callback) => {
      const { MARKET, OPERATION, DISTRIBUTE, JJKL, EFFECTIVE, CUSTOM1 } = DailyReports.REPORTS_TEMPLATE_TYPES
      const { reportTemplate } = this.configForm
      const [, rowIndex] = rule.fullField.split('.')
      const gameRow = this.configForm.gameList[rowIndex]

      try {
        if ([MARKET, OPERATION, EFFECTIVE].includes(reportTemplate)) {
          if (!gameRow.gameGroupIds?.length) {
            throw new Error('请选择游戏组')
          }

          const validPlatform = EFFECTIVE === reportTemplate ? gameRow.platforms.length : gameRow.platform
          if (!validPlatform) {
            throw new Error('请选择平台')
          }
        }
        if ([DISTRIBUTE].includes(reportTemplate)) {
          if (!gameRow.middleGameIds?.length) {
            throw new Error('请选择中间件游戏')
          }

          if (!gameRow.platforms?.length) {
            throw new Error('请选择平台')
          }
        }

        if (MARKET === reportTemplate) {
          if (!moment(gameRow.startDate).isValid()) {
            throw new Error('请选择计算起始日')
          }
        }

        if ([EFFECTIVE, CUSTOM1, JJKL].includes(reportTemplate)) {
          // todo
        } else {
          // 平台投放、平台运营需要校验表格名称
          if (!gameRow.name?.trim()?.length) {
            throw new Error('请输入表格显示名称')
          }
        }

        // 平台投放、平台运营需要校验重复项
        if ([MARKET, OPERATION, EFFECTIVE, CUSTOM1].includes(reportTemplate)) {
          const list = JSON.parse(JSON.stringify(this.configForm.gameList))
          duplicateCheck('gameGroupIds', list)
        }

        callback()
      } catch (e) {
        callback(new Error(e.message))
      }
    }

    const newMarketGameValidator = (rule, value, callback) => {
      const { NEW_OPERATION } = DailyReports.REPORTS_TEMPLATE_TYPES
      const { reportTemplate } = this.configForm
      const [, rowIndex] = rule.fullField.split('.')
      const gameRow = this.configForm.marketGameList[rowIndex]

      try {
        if (!gameRow.middleGameIds?.length) {
          throw new Error('请选择中间件游戏')
        }

        if (!gameRow.name?.trim()?.length) {
          throw new Error('请输入表格显示名称')
        }

        if ([NEW_OPERATION].includes(reportTemplate)) {
          let marketList = JSON.parse(JSON.stringify(this.configForm.marketGameList))
          // 多选的平台需要处理一下platform的值，因为多选是platforms接收的
          marketList = marketList.map((c) => ({ ...c, platform: c.platforms.join(',') }))
          duplicateCheck('middleGameIds', marketList)
        }
        callback()
      } catch (e) {
        callback(new Error(e.message))
      }
    }

    const newChannelGameValidator = (rule, value, callback) => {
      const { NEW_OPERATION } = DailyReports.REPORTS_TEMPLATE_TYPES
      const { reportTemplate } = this.configForm
      const [, rowIndex] = rule.fullField.split('.')
      const gameRow = this.configForm.channelGameList[rowIndex]

      try {
        if (!gameRow.middleGameIds?.length) {
          throw new Error('请选择中间件游戏')
        }

        if (!gameRow.name?.trim()?.length) {
          throw new Error('请输入表格显示名称')
        }

        if ([NEW_OPERATION].includes(reportTemplate)) {
          let channelGameList = JSON.parse(JSON.stringify(this.configForm.channelGameList))
          // 多选的平台需要处理一下platform的值，因为多选是platforms接收的
          channelGameList = channelGameList.map((c) => ({ ...c, platform: c.platforms.join(',') }))
          duplicateCheck('middleGameIds', channelGameList)
        }
        callback()
      } catch (e) {
        callback(new Error(e.message))
      }
    }

    const sendTimeValidator = (rule, value, callback) => {
      if (this.configForm.sendTime.sendTimeDay.length === 0) callback(new Error('周发送频率至少选择一天'))
      callback()
    }

    const dataTimeValidator = (rule, value, callback) => {
      if (this.effectiveType) {
        let { dataType, startDate, endDate } = this.configForm

        if (dataType === DailyReports.DATA_TYPE.BY_DAY) {
          if (!startDate) {
            return callback(new Error('请选择数据报表起始时间'))
          }
        }

        if (!endDate) {
          endDate = moment().format('YYYY-MM-DD')
        }

        // const limitDate = moment(endDate).subtract(91, 'days')

        // if (limitDate.isAfter(startDate)) {
        //   return callback(new Error('日期范围不能超过90天'))
        // }
      }

      callback()
    }

    const webhookValidator = (rule, value, callback) => {
      try {
        this.dingWebhooks.forEach((i, index) => {
          if (!urlRegExp.test(i.url)) {
            throw new Error(`行${index + 1}：链接不正确`)
          }
        })

        callback()
      } catch (e) {
        callback(new Error(e.message))
      }
    }

    return {
      reportName: [{ required: true, message: '报表名称不能为空', trigger: 'blur' }],
      game: [{ validator: gameValidator, trigger: 'blur', required: true }],
      newMarketGame: [{ validator: newMarketGameValidator, trigger: 'blur', required: true }],
      newChannelGame: [{ validator: newChannelGameValidator, trigger: 'blur', required: true }],
      dataTime: [{ validator: dataTimeValidator, trigger: 'change', required: true }],
      sendTime: [{ validator: sendTimeValidator, trigger: 'change', required: true }],
      receiveType: [{ message: '接收方式至少选择一项', trigger: 'change', required: true }],
      sendOpIds: [{ message: '人员不能为空', trigger: 'change', required: true }],
      webhook: [{ validator: webhookValidator, trigger: 'change', required: true }]
    }
  }

  /**
   * @description: 生成起始投放日期列表 1号-31号
   */
  static makeHourRanges() {
    const ranges = []
    for (let i = 9; i < 25; i++) {
      if (i < 10) i = `0${i}`
      ranges.push(`${i}:00`)
      ranges.push(`${i}:30`)
    }
    // 去掉24:30
    return ranges.slice(0, -1)
  }

  /**
   * @description: 生成游戏默认配置行
   * @return {
   *   gameGroupIds: 多选，用于投放、运营日报
   *   middleGameIds: 多选，用于发行日报
   *   platforms：多选，用于发行日报
   *   platform：单选， 用于投放、运营日报
   *   startDate：用于投放日报的起始投放日下拉选择
   *   name: 表格显示名称
   * }
   */
  static makeDefaultGameRow() {
    return { gameGroupIds: [], middleGameIds: [], platforms: [], platform: '', startDate: '', name: '', _time: Date.now() }
  }

  /**
   * @description: 生成买量、渠道游戏默认配置行
   * @return {
   *   middleGameIds: 多选，用于新运营日报
   *   platform：单选， 用于新运营日报
   * }
   */
  static makeGameRow() {
    return { middleGameIds: [], platform: 0, platforms: [0], name: '' }
  }

  /**
   * @description: 日报推送配置表格选项参数
   */
  static getDailyPushGridOptions() {
    return {
      border: true,
      showHeaderOverflow: true,
      showOverflow: 'tooltip',
      columnConfig: {
        resizable: true
      },
      data: [],
      height: 500,
      columns: [
        { title: '任务开关', width: 70, slots: { default: 'switch' } },
        { field: 'id', title: '报表任务id', width: 90 },
        { field: 'reportName', title: '报表任务名称', width: 190 },
        { field: 'sendOpNames', title: '提醒人' },
        { field: 'reportTemplateName', title: '报表模板' },
        { field: 'sendTimeDesc', title: '定时发送时间', width: 320 },
        { field: 'createOpName', title: '新建人' },
        {
          field: 'createTime',
          title: '新建时间',
          formatter: ({ cellValue }) => datetimeToSec(cellValue)
        },
        { field: 'upOpName', title: '更新人' },
        { field: 'upTime', title: '更新时间', formatter: ({ cellValue }) => datetimeToSec(cellValue) },
        { title: '操作', width: 160, fixed: 'right', slots: { default: 'operation' } }
      ]
    }
  }

  /**
   * @description: 日报任务推送记录表格选项参数
   */
  static getRecordsGridOptions() {
    return {
      border: true,
      showHeaderOverflow: true,
      showOverflow: 'tooltip',
      columnConfig: {
        resizable: true
      },
      data: [],
      height: 500,
      columns: [
        { field: 'addTime', title: '新建时间', formatter: ({ cellValue }) => datetimeToSec(cellValue) },
        { field: 'reportName', title: '报表名称' },
        { field: 'reportType', title: '报表类型' },
        { field: 'sendOpNames', title: '提醒人' },
        {
          field: 'sendStatus',
          title: '发送状态',
          formatter: ({ row, cellValue }) => {
            const item = this.REPORTS_SEND_STATUS_LIST.find((s) => s.value === cellValue)
            let text = item?.label
            if (cellValue === this.REPORTS_SEND_STATUS.FAIL) {
              text = text.concat('：').concat(row.failMsg)
            }
            return text
          }
        },
        { field: 'upTime', title: '更新时间', formatter: ({ cellValue }) => datetimeToSec(cellValue) },
        { title: '操作', width: 180, fixed: 'right', slots: { default: 'operation' } }
      ]
    }
  }
}

/**
 * @description: 重复选择验证
 * @description: 平台运营、平台投放报表 游戏组+平台组合不能够重复
 * @param prop 需要校验的属性值
 * @param list 选择的游戏的全部行
 * @param needleIndex 需要校验的行，递增指针，递归进行每行的校验
 */
function duplicateCheck(prop, list, needleIndex = 0) {
  // 先找到作为指针的项
  const needle = list[needleIndex]
  const needleStrList = needle[prop].map((id) => `${id}-${needle.platform}`)

  // 剩余的项组合成一个id+platform的数组，与上面的needleList进行校验
  const restItems = list
    .filter((_, i) => i !== needleIndex)
    .map((item) => {
      // 把每个组的id和平台进行组合
      return item[prop].map((id) => `${id}-${item.platform}`)
    })
    .flat()

  const hasDuplicate = needleStrList.some((needle) => restItems.includes(needle))
  if (hasDuplicate) {
    throw new Error('[游戏组+平台]组合不能重复')
  }

  // 切换指针，校验下一列
  const nextIndex = needleIndex + 1
  if (nextIndex < list.length) {
    duplicateCheck(prop, list, nextIndex)
  }
}
